import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWpformsRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#7EABBA",
			d: "M19.4 7.2q.1-.7.7-1.2a2 2 0 0 1 2.5.4q.6.7.4 1.5c1.2.4 1 1 1 2v2.6l.4.3q.3 0 .4.4c.3.4.1 1.7.2 2.2v1q2.1.6 2.7 2.8l.2.7V21l-.2.5q-.4.8-1 1.2-.7.9-1.7 1 .1.5-.4.9-.6.3-1.3.2H11.5c-.7 0-1.7.1-1.8-.7v-4q-.8.6-1.8.8c-1.8.3-3.8-.2-4.1-2.2v-1.2l-.3-.6q-.3-1.2 0-2.2-.4-.7.2-1.3.3-.3.7-.2t.6.4v-.2c.3-.9 1.5-1 1.8-.1v.3q.4-.5 1-.4l.6.3q.3.6 0 1.1l.7.6q.3.3.2.6-.1.5-.5.8l.2.4.6-.5V14q0-1 1-1.5c0-.7-.2-3.5 0-3.9q.3-.5 1-.7-.1-.8.4-1.5c1-1.3 3-.8 3.2.8h.8q0-.6.6-.7.4.1.7.6l.3-.3q.9-.6 1 .4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B95B1B",
			d: "M19.4 7.2q.1-.7.7-1.2a2 2 0 0 1 2.5.4q.6.7.4 1.5c1.2.4 1 1 1 2v2.6l.4.3q.3 0 .4.4c.3.4.1 1.7.2 2.2v1l-.7.2-4.6 1.2-1.6.4-.8.1-1.8-.4L12 17l-1.6-.3-.7-.2V14q0-1 1-1.5c0-.7-.2-3.5 0-3.9q.3-.5 1-.7-.1-.8.4-1.5c1-1.3 3-.8 3.2.8h.8q0-.6.6-.7.4.1.7.6l.3-.3q.9-.6 1 .4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E1772E",
			d: "M19.4 7.2q.1-.7.7-1.2a2 2 0 0 1 2.5.4q.6.7.4 1.5c1.2.4 1 1 1 2v2.6l.4.3q.3 0 .4.4c.3.4.1 1.7.2 2.2v1l-.7.2v-1.9c0-.8.2-1.5-.8-1.7V9.5l-.2-.8c-1-.9-4.7-1-6-1v3.9l-1.7.3h-2.9q-.3 1.4.3 2.8l.3.5.6 1q1.4 1.3 3.4 1.3v.8l-1.8-.4L12 17l-1.6-.3-.7-.2V14q0-1 1-1.5c0-.7-.2-3.5 0-3.9q.3-.5 1-.7-.1-.8.4-1.5c1-1.3 3-.8 3.2.8h.8q0-.6.6-.7.4.1.7.6l.3-.3q.9-.6 1 .4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#813F13",
			d: "M19.4 7.2q.1-.7.7-1.2a2 2 0 0 1 2.5.4q.6.7.4 1.5c1.2.4 1 1 1 2v2.6l.4.3q.3 0 .4.4c.3.4.1 1.7.2 2.2v1l-.7.2v-1.9c0-.8.2-1.5-.8-1.7V9.5l-.2-.8c-1-.9-4.7-1-6-1s-5 .1-6 1l-.1.3v4c-1 .3-1 .9-1 1.8v1.9l-.6-.2V14q0-1 1-1.5c0-.7-.2-3.5 0-3.9q.3-.5 1-.7-.1-.8.4-1.5c1-1.3 3-.8 3.2.8h.8q0-.6.6-.7.4.1.7.6l.3-.3q.9-.6 1 .4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B95B1B",
			d: "M12.1 7.7c0-1.7 2-2 2.6-.5H14l-1.4.3z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5A2D06",
			d: "M12.7 7.5q0-.9 1-.7.3.1.4.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B95B1B",
			d: "M20 7.2q.1-.7.8-1l1 .1q.4.3.6.8l.1.6-.5-.2-1.5-.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5A2D06",
			d: "M20.5 7.3q0-.3.4-.5h.5q.5.2.6.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "M15.8 9.6a1 1 0 1 1 .3 2 1 1 0 0 1-.3-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1C1C20",
			d: "M16 10a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5A2D06",
			d: "M15.6 8.5q.9 0 1 .8h-1.2q-.5 0-.7.3 0-1 1-1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FCD395",
			d: "M17.3 11.6q1 0 1.8.3H21c0 .9.1 1.2-.3 2v.2q-.3.1-.4.4l-.2.1-.8.6-.6.2h-.4l-.3.1c-1.6.3-3.6-.3-4.2-1.9q-.4-.8-.1-1.7h1.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5A2D06",
			d: "M17.3 11.6q1 0 1.8.3c0 .9 0 1.5-1 1.9q-.3 0-.5.2l-.3.7-.3-.8-.7-.2q-.9-.6-.7-1.7v-.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#AF6051",
			d: "M17.3 11.9c.2 0 1 0 1.3.2v.1c0 .5-.9.5-1.2.5l-1.1-.1q-.4-.2-.3-.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E58A5B",
			d: "M12.7 11.9h1v1.7c.7 1.6 2.7 2.2 4.3 2l.3-.1.4-.1.6-.2.8-.6h.2q0-.3.3-.5V14c.5-1 .4-1.2.4-2.1h1a5 5 0 0 1-.4 2.7c-1 2.2-4 2.9-6.1 2.1q-1-.2-1.6-.8l-.6-.7-.3-.5q-.6-1.4-.3-2.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5A2D06",
			d: "M20.7 14v.7q0 .8-1 1.1h-.3q-.6 0-1.1-.3l.4-.1.6-.2.8-.6h.2q0-.3.3-.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#AF6051",
			d: "M19.8 15.8q0-.5.3-.9.3-.2.7-.2-.3.8-1 1.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "m19.3 15.2-.1.3-.2.1-.3-.2zm1-.7.3-.4q.1.6-.3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FCD395",
			d: "M20.7 14.7v.6c0 .6-1 1-1.4.7l.1-.1h.4q.7-.4 1-1.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "M18.6 9.6a1 1 0 1 1 .3 2 1 1 0 0 1-.3-2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1C1C20",
			d: "M18.5 10a.7.7 0 1 1 .3 1.4.7.7 0 0 1-.3-1.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#5A2D06",
			d: "M18.6 8q.5-.1 1 .2.2.3.2.8l-.5-.3h-1.5q.2-.7.8-.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B95B1B",
			d: "M3.5 14.7q-.4-.7.2-1.3.3-.3.7-.2t.6.4v-.2c.3-.9 1.5-1 1.8-.1v.3q.4-.5 1-.4l.6.3q.3.6 0 1.1l.7.6q.3.3.2.6-.1.5-.5.8l-.3.1-.1.3-.2.4c-.2.4 0 .8-.5 1.2q-.5.7-1.4.8-1.4 0-2-1l-.5-.9-.3-.6q-.3-1.2 0-2.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#813F13",
			d: "M3.5 14.7q-.4-.7.2-1.3.3-.3.7-.2t.6.4v-.2c.3-.9 1.5-1 1.8-.1v.3q.4-.5 1-.4l.6.3q.3.6 0 1.1l.7.6q.3.3.2.6-.1.5-.5.8l-.3.1-.1.3-.2.4c-.2.4 0 .8-.5 1.2l.1-.2.1-.7c-.5.4-.6.4-1.2.2q1-.5 1.2-1.7h.5q.6-.4 0-.8H8l-.2-.5c-.6-.1-1.7-.3-2.2-.2l-1.6.2v.5q-.3 1.4.7 2.2v.6Q5 19 6 19.4h.3q-1.4 0-2-1l-.5-.9-.3-.6q-.3-1.2 0-2.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E1772E",
			d: "M4.2 13.7a.5.5 0 1 1 .2 1 .5.5 0 0 1-.2-1m1.7-.4h.3l.2.4v.3q-.2.3-.5.2c-.4 0-.7-.6 0-1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B95B1B",
			d: "M5.9 13.3q.3.1.3.4v.3q-.2.3-.5.2zm1.6.3q1.1.2.4 1h-.4q-.6-.5 0-1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E1772E",
			d: "M5.6 14.7H6v.7h-.6c-.5.1-.6 0-.6.6s.4 1.3 1 1.3H6v.8q-.6-.1-1.2-.5-1-.8-.8-2.2V15z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#813F13",
			d: "m6 15.4 1 .1v.7q0 1-1.1 1.1-1.1-.2-1.1-1.3 0-.6.6-.5zm19 3.2.6.2a3 3 0 0 1 1.4 1.7q.3.5.1 1 0 .4-.2.7l-.2.5q-.7.9-1.7 1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#E1772E",
			d: "M25 19.2q.6 0 1 .6.5.4.6 1.1v.2q-.8.4-1.7.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#B95B1B",
			d: "M26.6 20.9v.6A2 2 0 0 1 25 23v-1.6l1.6-.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D3E9ED",
			d: "m8.2 18.6.5-.4q0 1.3-1.1 2c-1 .5-2.5.1-3-1q.3.4.8.6.8.3 1.6 0t1.2-1.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "M25 18.2q1-.1 1.7.6.7.5.8 1.4-.3 0-.4.3l-.2-.4q-.5-.9-1.3-1.3l-.6-.2zM8.4 17c.2.2.3.9.3 1.2l-.5.4c0-.3.2-1 0-1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D3E9ED",
			d: "m27 20.5.5-.3q0 .7-.3 1.4 0-.6-.2-1.1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#C4D6E1",
			d: "M4.5 19.2v-.1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D3E9ED",
			d: "M24.3 17.2V24l-.5.2H10.7l-.3-.2c-.2-.2-.1-.8-.1-1v-5.7l2.1.7q1 1 2.2 1.8l.7.4.8-.7.7-.7.5.2.5-.2 1.5 1.4a10 10 0 0 0 3.1-2.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "m10.3 17.3 2.1.7q1 1 2.2 1.8l.7.4.8-.7.7-.7.5.2v5.2h-6.6l-.3-.2c-.2-.2-.1-.8-.1-1z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0099EE",
			d: "M14.5 22.4h2.8v.9h-2.8zm0-1.6h2.8v.8h-2.8zm-3.1 1.6h2.4v.8h-2.4zm0-1.6h2.4v.8h-2.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0069AB",
			d: "M17.3 22.4h5.9v.9h-5.9zm0-1.6h6v.8h-6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "m13.3 18 2.4.6h.4l-.5.5-.4.4-.6-.4zm7.9 0-1.8 1.5-.4-.5-.5-.5 1.6-.3zm3.8-1q.9.3 1.4.8l.2.3a3 3 0 0 0-1.7-.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D3E9ED",
			d: "M9.3 18.6q.3 0 .3-.3v1q-.4.6-1.2 1l.8-1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEFEFE",
			d: "m9.2 17.5.5-.3v1.1l-.3.3h-.1z"
		})
	]
});
export default SvgWpformsRegularIcon;
